import { EventEmitter } from '@angular/core';
var ProfileContentComponent = /** @class */ (function () {
    function ProfileContentComponent() {
        this.active = 'profile';
        this.editClick = new EventEmitter();
    }
    Object.defineProperty(ProfileContentComponent.prototype, "poliza", {
        get: function () {
            if (this.paymentData && this.paymentData.length) {
                return this.paymentData[0].policyNumber || this.paymentData[0].number || '';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileContentComponent.prototype, "cuentaBancaria", {
        get: function () {
            if (this.paymentData && this.paymentData.length) {
                return this.paymentData[0].bankAccount || this.paymentData[0].iban || this.paymentData[0].account || '';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileContentComponent.prototype, "tipoPago", {
        get: function () {
            if (this.paymentData && this.paymentData.length) {
                return this.paymentData[0].periodicity || this.paymentData[0].paymentMethod || this.paymentData[0].paymentType || '';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    ProfileContentComponent.prototype.onProfileAction = function (clickResult) {
        console.log('Llega a profile-content:', clickResult); // 👈 debug
        this.active = clickResult.section;
    };
    return ProfileContentComponent;
}());
export { ProfileContentComponent };
